import { Link, useNavigate } from 'react-router-dom'
import { AuthLayout } from '../../layout.tsx'
import { Button } from '@/common/components/Button.tsx'
import { AppRoutePaths } from '../../../../../routing/route_paths.ts'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '@/storage/store.ts'
import {
  POSTResetPasswordLink,
  resetRequestState,
} from '@/app-storage/user/resetPasswordEmailSlice.ts'
import { useEffect } from 'react'
import { useAppAlert } from '@/app/AppAlertProvider.tsx'
import { REQUEST_STATUS } from '@/app/common/types_and_interfaces.ts'
import { CircleLoader } from '@/app/common/components/CircleLoader.tsx'
import { useTranslation } from 'react-i18next'
import AceScholarshipsLogo from '@assets/AceScholarshipLogo1.jpg'

export default function CheckEmailPage() {
  const { t: translate } = useTranslation()
  const navigate = useNavigate()
  const { fireAlert } = useAppAlert()
  const asyncDispatch = useDispatch<AppDispatch>()
  const ResetPasswordEmailBase = useSelector(
    (state: RootState) => state.ResetPasswordEmail
  )
  const ResetPasswordEmailState = ResetPasswordEmailBase.request

  const RedirectToLogin = () => {
    navigate(AppRoutePaths.auth.login)
  }
  const ResendEmailLink = () => {
    asyncDispatch(resetRequestState())
    if (ResetPasswordEmailBase.email) {
      asyncDispatch(
        POSTResetPasswordLink({ email: ResetPasswordEmailBase.email })
      )
    }
  }

  useEffect(() => {
    if (ResetPasswordEmailState.status == REQUEST_STATUS.FAILED) {
      fireAlert({
        variant: 'error',
        message: ResetPasswordEmailState.error.message,
      }).then()
      asyncDispatch(resetRequestState())
      return
    }
    if (ResetPasswordEmailState.status === REQUEST_STATUS.SUCCESS) {
      asyncDispatch(resetRequestState())
      navigate(AppRoutePaths.auth.forgot_password.check_email)
      return
    }
  }, [ResetPasswordEmailState.status])

  return (
    <AuthLayout>
      <AuthLayout.Content className="space-y-5">
        <div className="flex flex-col">
          <img
            alt={translate('ace_logo')}
            src={AceScholarshipsLogo}
            className="mx-auto h-auto"
            width="100%"
          />
          <h3 className="text-lg font-semibold text-gray-900 text-center mt-10 mb-4">
            {translate('check_your_email')}
          </h3>
          <div className="text-sm text-gray-500 font-medium text-center mb-7">
            {translate('please_click_the_link_sent_to_your_email')}{' '}
          </div>
          <div className="flex justify-center mb-5">
            <Button onClick={RedirectToLogin}>{translate(`log_in`)}</Button>
          </div>
          <div className="flex items-center justify-center gap-1">
            <span className="text-xs font-medium text-gray-500">
              {translate('didnt_receive_an_email')}
            </span>
            <Link
              to={''}
              onClick={ResendEmailLink}
              className="text-xs font-medium link text-primary"
            >
              {ResetPasswordEmailState.status == REQUEST_STATUS.IN_FLIGHT && (
                <CircleLoader size="sm" className="mr-1" />
              )}
              {ResetPasswordEmailState.status != REQUEST_STATUS.IN_FLIGHT &&
                translate(`resend`)}
            </Link>
          </div>
        </div>
      </AuthLayout.Content>
    </AuthLayout>
  )
}
